<template>
  <section class="model-select content-container-column-narrower">
    <div class="model-group">
      <ul>
        <li
          v-for="model in $store.state.selectedSeries.models"
          v-bind:key="model.tag"
          v-on:click="setModel(model)"
          @keydown="handleKeydown($event, model)"
          tabindex="0"
        >
          <router-link to="/customizer">
            <img :src="getImageUrl(`${model.tag}.png`)" />
            <div class="pool-title-row">
              <h4 class="pool-title" v-if="getT">{{ model.title }}</h4>
              <span class="new-indicator" v-if="isNew(model)">
                {{ getT.static.pool_select[0].new_label }}
                {{getT.static.pool_select[0].new}}
              </span>
            </div>
            <div class="info-row">
              <p v-if="getT" class="size">
                {{
                  model.options.len.choices[0].measurement + model.options.len.unit + ' ' + 
                  getT.options.size[0].length_label_abbreviation + ' x ' + 
                  model.options.width.choices[0].measurement + model.options.width.unit +  ' ' + 
                  getT.options.size[0].width_label_abbreviation + ' x ' + 
                  model.options.depth.choices[0].measurement + model.options.depth.unit + ' ' + 
                  getT.options.size[0].height_label_abbreviation
                }}
                <label>{{
                  getDimensionLabel(model)
                }}</label>
              </p>
                <div class="bottom-right-el" :class="{ 'hide': !showPricing }">
                <p>{{ formatCurrency(model.price) }}</p>
                <label v-if="getT">{{getT.static.pool_select[0].msrp}}</label>
                </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import {formatCurrency} from '@/helpers/price';
import { categoryOfPool } from '../../poolData';

export default {
  name: 'ModelSelect',
  computed: {
    ...mapGetters(['getT','showPricing']),
  },
  methods: {
    getDimensionLabel(model) {
      if (categoryOfPool(model.tag)?.tag == 'custom' && model.tag != 'sp105') {
        return this.getT.static.pool_select[0].model_select[0]
        .interior_dimensions_label
      } else {
        return this.getT.static.pool_select[0].model_select[0]
        .overall_dimensions_label
      }
    },
    formatCurrency,
    setModel(model) {
      this.$store.dispatch('setModel', model);
      
      // track event for Google Analytics
      this.$gtag.event(model.title + ' clicked', {
        'event_category': 'Pool  Pick',
        'event_label': model.title + ' clicked'
      });
    },
    handleKeydown(event, model) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.setModel(model);
        this.$router.push('/customizer');
      }
    },
    getCategoryModels(categoryTag) {
      const models = [];
      const theCategory = this.$store.state.pools.find(
        (categ) => categ.tag === categoryTag
      );

      // series once called "lines" and in storyblok schema are named that way
      theCategory.series.forEach((series) => {
        models.push(...series.models);
      });
      return models;
    },
    getImageUrl(filename) {
      try {
        var images = require.context('@/assets/images/select_thumbs');
        return images('./' + filename);
      } catch (e) {
        console.error('Failed to load image file - ', e);
        return '';
      }
    },
    sizeIsCustomizable(model) {
      return (
        model.options.len.choices.length > 1 ||
        model.options.width.choices.length > 1 ||
        model.options.depth.choices.length > 1
      );
    },
    isNew(model) {
      // true for modular pools for 1 year after jul 15 2025
      if (model.tag === 'my-new-model') {
        const expiryDate = new Date('2026-08-06');
        return new Date() < expiryDate;
      }
      return false;
    }
  },
};
</script>
<style lang="scss" scoped>
section.model-select {
  z-index: 1;
  padding-bottom: 2rem;
  .model-group {
    display: block;
  }
  ul {
    margin: 8px 0 0 0;
    list-style: none;
    padding-inline-start: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(298px, 1fr));
    justify-content: center;
    grid-gap: 20px;
    li {
      background: #213354;
      border: none;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      @media #{$desktop} {
        &:hover {
          background: radial-gradient(
            circle at center,
            rgba(255, 255, 255, 0.1),
            #213354
          );
          box-shadow: inset 0 0 3px rgba(255, 255, 255, 0.5);
        }
      }
      a {
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: space-between;
        padding: 18px;
        text-decoration: none;
        cursor: pointer;
        > * {
          user-select: none;
        }
        img {
          margin: 0 auto;
          width: 100%;
          max-width: 266px;
          aspect-ratio: 3/2;
          object-fit: contain;
        }
        h4.pool-title {
          font-size: 1.625rem;
          letter-spacing: 0.7px;
          font-family: 'Austin Bold', serif;
          font-weight: unset;
        }
        p {
          font-family: 'Europa Light';
        }
        label {
          font-family: 'Europa Light';
          display: block;
          color: $lighter-gray;
          font-size: 0.75rem;
          margin-top: 3px;
        }
        .pool-title-row,
        .info-row {
          display: flex;
          justify-content: space-between;
          gap: 5px;
        }
        .pool-title-row {
          align-items: center;
          margin-bottom: 1rem;
          
          .new-indicator {
            height: 1.625rem;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 8px;
            background-color: $teal;
            font-size: 0.875rem;
            letter-spacing: 0.14875rem; 
            font-family: 'Europa Bold';
            text-transform: uppercase;
          }
        }
        .bottom-right-el {
          text-align: right;
          &.hide {
            display: none;
          }
        }
      }
    }
  }
  @media only screen and (max-width: $lg) {
    ul {
      grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
    }
  }
  @media only screen and (max-width: $sm-md) {
    ul {
      grid-template-columns: none;
    }
  }
}
</style>
